import { useForm } from 'react-hook-form';
import { Form, Grid, useAppSelector, RootState } from '../../base';
import { FeatureFlags, ISaveJobForm } from '../../common';
import CandidatesMenuDrawer from '../JobApplicationEntity/CandidatesMenuDrawer';
import { organizationSelectors } from '../../actions';

import {
    JobOverviewContent,
    JobRequirementsAndBenefitsContent,
} from '../JobCommonComponents';
import JobStepsViewer from '../JobCommonComponents/JobStepsViewer';
import JobQuestionsViewer from '../JobCommonComponents/JobQuestionsViewer';
import { JobEntityWrapperBox } from './JobEntity.styles';
import { JobEntityHeader } from './JobEntityHeader';

const JobEntity = () => {
    const methods = useForm<ISaveJobForm>();
    const isCandidateQuestionsFeatureFlagOn = useAppSelector(
        (state: RootState) =>
            organizationSelectors.isFlagOn(
                state,
                FeatureFlags.CANDIDATE_QUESTIONS
            )
    );

    return (
        <JobEntityWrapperBox>
            <Grid container rowSpacing={2}>
                <Grid item xs={12}>
                    <JobEntityHeader />
                </Grid>
                <Grid item xs={12}>
                    <Grid container columnSpacing={2}>
                        <Grid item xs={6}>
                            <JobOverviewContent isEmployerView />
                        </Grid>
                        <Grid item xs={6}>
                            <Grid container spacing={2}>
                                <Grid item xs={12}>
                                    <JobStepsViewer isEmployerView />
                                </Grid>
                                <Grid item xs={12}>
                                    <JobRequirementsAndBenefitsContent
                                        isEmployerView
                                    />
                                </Grid>
                                {isCandidateQuestionsFeatureFlagOn && (
                                    <Grid item xs={12}>
                                        <Form methods={methods}>
                                            <JobQuestionsViewer
                                                isEmployerView
                                            />
                                        </Form>
                                    </Grid>
                                )}
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
            <CandidatesMenuDrawer />
        </JobEntityWrapperBox>
    );
};

export default JobEntity;
